import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFashion: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"fashion, wear, clothes, t-shirt"} maskId="square-filled-radius-0-stroke-1-IconFashion"><path d="M9.32679 3.35454L9.15543 2.79297L0.878906 6.8536L2.7875 12.2557L4.99855 11.1972V21.0005H18.9986V11.1972L21.2096 12.2557L23.1182 6.8536L14.8417 2.79297L14.6703 3.35454C14.2194 4.83217 13.0905 5.52299 11.9986 5.52299C10.9066 5.52299 9.77766 4.83217 9.32679 3.35454Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFashion;
